import { render } from "./doctor-patientprofile.vue?vue&type=template&id=63eef0b0"
import script from "./doctor-patientprofile.vue?vue&type=script&lang=js"
export * from "./doctor-patientprofile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__